import { render, staticRenderFns } from "./AddPurchaseBill.vue?vue&type=template&id=0a732f8a&"
import script from "./AddPurchaseBill.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports